export default "__VITE_ASSET__DLZDTLbV__"